<template>
  <v-dialog
    v-model="showNewDialog"
    scrollable
    content-class="position-absolute top-0"
    eager
    max-width="800px"
  >
    <v-form>
      <v-card class="window-card">
        <v-card-title>
          <span class="md-title" style="color: #67ad5b">模型申请</span>
        </v-card-title>
        <v-card-text style="padding-top: 0px">
          <v-expansion-panels flat :value="0">
            <v-expansion-panel>
              <v-expansion-panel-header>申请信息</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-select
                  v-model="formData.model_category"
                  :items="selectMetaListData"
                  label="元件类型"
                  color="#4caf50"
                  readonly
                ></v-select>
                <v-text-field
                  v-model="formData.model_name"
                  label="模型名称"
                  color="#4caf50"
                  readonly
                ></v-text-field>
                <v-select
                  v-model="formData.one_level_classify"
                  :items="selectMajorListData"
                  item-text="name"
                  color="#4caf50"
                  item-value="code"
                  label="专业分类"
                  no-data-text="暂无数据"
                  readonly
                ></v-select>
                <v-select
                  item-text="name"
                  color="#4caf50"
                  item-value="code"
                  no-data-text="暂无数据"
                  label="二级分类"
                  readonly
                ></v-select>
                <v-select
                  item-text="name"
                  color="#4caf50"
                  item-value="code"
                  no-data-text="暂无数据"
                  label="三级分类"
                  readonly
                ></v-select>
                <v-textarea
                  v-model="formData.description"
                  label="模型描述"
                  auto-grow
                  color="#4caf50"
                  readonly
                ></v-textarea>
                <div>
                  <v-subheader>模型图片</v-subheader>
                  <v-img
                    :src="formData.model_image"
                    height="180"
                    contain
                    light
                    position="left left"
                  ></v-img>
                </div>
                <div>
                  <v-subheader>模型全景图片</v-subheader>
                  <v-img
                    :src="formData.model_file"
                    height="180"
                    contain
                    light
                    position="left left"
                  ></v-img>
                </div>
                <div>
                  <v-subheader>模型视频资料</v-subheader>
                  <div v-if="formData.model_video_file">
                    <v-alert
                      border="left"
                      colored-border
                      color="deep-purple accent-4"
                      elevation="2"
                      type="success"
                    >
                      已上传
                    </v-alert>
                    <a :href="formData.model_video_file" target="_blank" style="padding-left: 15px"
                      >下载</a
                    >
                  </div>
                  <div v-if="!formData.model_video_file">
                    <v-alert
                      border="left"
                      colored-border
                      type="error"
                      color="red accent-4"
                      elevation="2"
                    >
                      未上传
                    </v-alert>
                  </div>
                </div>
                <div style="margin-bottom: 20px">
                  <v-subheader>模型CAD文件</v-subheader>
                  <div v-if="formData.model_cad_file">
                    <v-alert
                      border="left"
                      colored-border
                      color="deep-purple accent-4"
                      elevation="2"
                      type="success"
                    >
                      已上传
                    </v-alert>
                    <a :href="formData.model_cad_file" target="_blank" style="padding-left: 15px"
                      >下载</a
                    >
                  </div>
                  <div v-if="!formData.model_cad_file">
                    <v-alert
                      border="left"
                      colored-border
                      type="error"
                      color="red accent-4"
                      elevation="2"
                    >
                      未上传
                    </v-alert>
                  </div>
                </div>
                <v-textarea
                  v-model="formData.model_remark"
                  label="申请备注"
                  color="#4caf50"
                  auto-grow
                  readonly
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>申请记录</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headers"
                  :items="this.applyList"
                  hide-default-footer
                  class="paginated-table table-striped table-hover"
                  no-data-text="暂无数据"
                >
                  <template v-slot:item.status="{ item }">{{ statusDict[item.status] }}</template>
                  <template v-slot:item.update_at="{ item }"
                    ><span>{{ dateFormat(item.update_at) }}</span></template
                  >
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>意见回复</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  v-model="auditOpinion"
                  label="内容"
                  auto-grow
                  color="#4caf50"
                  dense
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions md-alignment="right" style="margin-right: 0px">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="agree">同 意</v-btn>
          <v-btn class="error" @click="reject">驳 回</v-btn>
          <v-btn color="success" @click="cancel">关 闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { userInfo } from '@/api/user';

export default {
  props: {
    showNewDialog: {
      type: Boolean,
      default: false,
    },
    metaListData: {
      type: Array,
      default: [],
    },
    formData: {
      type: Object,
      default: () => {},
    },
    regularImg: {
      type: String,
      default: './img/image_placeholder.jpg',
    },
  },

  data() {
    return {
      headers: [
        {
          text: '申请/驳回',
          align: 'center',
          value: 'status',
          sortable: false,
        },
        { text: '意见', align: 'center', value: 'remark', sortable: false },
        { text: '日期', align: 'center', value: 'update_at', sortable: false },
        { text: '作者', align: 'center', value: 'zname', sortable: false },
      ],
      uid: '',
      required: '',
      auditOpinion: '',
      form: {},
      applyList: [],
      // 状态字典
      statusDict: {},
      // 专业分类
      selectMajorListData: [],
      imgurl1: require('/public/img/view.png'),
    };
  },
  components: {},
  created() {
    this.uid = this.$route.query.uid || '';

    //更新状态字典
    this.$dic.getStatusList(res => {
      this.statusDict = res.reduce((pre, next) => {
        pre[next.index] = next.name;
        return pre;
      }, {});
    });

    // 专业分类
    this.$dic.getCategoryList(
      {
        cate_type: this.formData.model_category,
        level: '1',
      },
      res => {
        this.selectMajorListData = res;
      }
    );

    // 申请记录
    this.applyList = [];
    this.formData.apply_list.forEach(item => {
      let tempData = {
        uid: item.operator,
      };
      userInfo(tempData).then(res => {
        if (res.code === '200') {
          this.applyList.push({ ...item, ...{ zname: res.data.name } });
        }
      });
    });
  },
  computed: {
    selectMetaListData() {
      return this.metaListData.map(item => {
        return {
          text: item.name,
          value: item.value,
        };
      });
    },
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    /**
     * 关闭
     */
    cancel() {
      this.$emit('handleCancel', {});
    },
    /**
     * 反驳
     */
    reject() {
      this.$emit('handleReject', { option: this.auditOpinion });
    },
    /**
     * 通过
     */
    agree() {
      this.$emit('handleAgree', { option: this.auditOpinion });
    },
  },
};
</script>
<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.img {
  width: 120px;
  height: 180px;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0px;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0px !important;
}

.image-container {
  max-width: 50%;
}

.v-subheader.theme--light {
  padding: 0px;
  height: 30px;
}
.v-expansion-panel-header {
  padding: 16px 0;
  font-weight: 200;
  color: #3c4858 !important;
}
.v-expansion-panel-header--active {
  color: #4caf50 !important;
}
::v-deep
  .v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
  .v-icon {
  color: #4caf50 !important;
}
</style>
